import { DateTime } from 'luxon'

import { LanguageCode } from '../constants/language-codes'
import { languages } from '../constants/languages'
import { MedicalId } from '../types'

export const transformV2 = (urlString: string): MedicalId => {
  let decodedUrl = urlString
  if (urlString.startsWith('https://readtwiceme.com/payload=%5B')) {
    decodedUrl = decodeURI(urlString)
  }

  const payload = decodedUrl.split('payload=')[1] ?? ''
  const decodedPayload = decodeURIComponent(payload)
  const obj = JSON.parse(decodedPayload) ?? []

  // Example format '18 May, 1992',
  const birthDate = DateTime.fromFormat(obj[0], 'd LLL, yyyy', {
    locale: 'en',
  })

  const language1 = languages.find(({ name }) => name === obj[18]?.name)
  const language2 = languages.find(({ name }) => name === obj[19]?.name)
  const language3 = languages.find(({ name }) => name === obj[20]?.name)

  const payloadLanguages: LanguageCode[] = []
  if (language1) {
    payloadLanguages.push(language1.code)
  }
  if (language2) {
    payloadLanguages.push(language2.code)
  }
  if (language3) {
    payloadLanguages.push(language3.code)
  }

  const emergencyContacts = []
  if (obj[1]) {
    emergencyContacts.push({
      name: obj[1],
      relationship: obj[7],
      phoneNumber: obj[4]?.number,
      countryCode: obj[4]?.countryInfo?.flagId,
    })
  }

  if (obj[2]) {
    emergencyContacts.push({
      name: obj[2],
      relationship: obj[8],
      phoneNumber: obj[5]?.number,
      countryCode: obj[5]?.countryInfo?.flagId,
    })
  }

  if (obj[3]) {
    emergencyContacts.push({
      name: obj[3],
      relationship: obj[9],
      phoneNumber: obj[6]?.number,
      countryCode: obj[6]?.countryInfo?.flagId,
    })
  }

  const medicalId: MedicalId = {
    id: '',
    fullName: obj[11],
    dateOfBirth: birthDate.toFormat('yyyy-MM-dd'),
    gender:
      obj[12] === 'Female' ? 'female' : obj[12] === 'Male' ? 'male' : undefined,
    nationality: obj[24]?.flagId,
    languages: payloadLanguages,
    emergencyContacts,
    chronicConditions: obj[22],
    pacemaker: obj[26],
    organDonor: obj[25],
    religion: obj[28],
    eyeColor: obj[10],
    systemOfMeasurement: obj[23] === 'cm/kg' ? 'metric' : 'imperial',
    height: obj[13],
    weight: obj[30],
    identificationCharacteristics: obj[14],
    insuranceCompanyName: obj[15],
    insuranceNumber: obj[17],
    insurancePhoneNumber: obj[16]?.number,
    insurancePhoneNumberCountryCode: obj[16]?.countryInfo?.flagId,
    passportNumber: obj[27],
  }

  return medicalId
}
